import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import { tags } from "../../consts/Tags";
import ButtonRounded from "../global/buttons/ButtonRounded";

export default class DebriefPanel extends Phaser.GameObjects.Container {
   constructor(scene) {
      super(scene, 0, 0, []);

      this.soundManager = scene.soundManager

      this.scene = scene;
      scene.add.existing(this);

      // Ajout du fond
      let background = this.scene.add.rectangle(0, 0, 800, this.scene.height, Colors.Elmt.LightGrey).setOrigin(0);
      this.add(background);

      // Ajout de la bande
      let bande = this.scene.add.rectangle(0, 0, 80, background.height, Colors.Elmt.Blue).setOrigin(0);
      this.add(bande);

      // Ajout du titre
      let debrief = this.scene.add.text(160, 66, "DEBRIEF", {
         fontSize: '14px',
         fontFamily: FONTS.InterRegular,
         color: Colors.Text.DarkGrey
      }).setOrigin(0)
      this.add(debrief);

      
      let line = this.scene.add.rectangle(160, 112, 560, 1, Colors.Elmt.DarkGrey).setOrigin(0);
      this.add(line);

      // Ajout du texte
      const configText = {
         fontSize: '24px',
         fontFamily: FONTS.Inter24Medium,
         color: Colors.Text.Black,
         wordWrap: {
            width: 560
         },
         tags:tags
      }

      let txt = "L’identification géographique d’un cliché repose sur deux piliers complémentaires : l’extraction de données invisibles et l’analyse visuelle du terrain.\n\n"
         + "La première étape consiste à examiner les <class=\"Inter24Bold_Orange\">métadonnées</class>, aussi appelées fichiers <class=\"Inter24Bold_Orange\">EXIF</class>. Ces informations, intégrées directement au fichier numérique, peuvent révéler les coordonnées GPS exactes du lieu de prise de vue, ainsi que l’heure précise et le modèle d’appareil utilisé. Toutefois, cette piste est souvent complexe car la majorité des réseaux sociaux suppriment ces données pour protéger la vie privée des utilisateurs.\n\n" 
         + "Si ces données sont absentes, il faut alors utiliser <class=\"Inter24Bold_Orange\">Google Maps</class>. Cette méthode consiste à observer les détails de l’image, comme un monument, une enseigne ou une plaque de rue. En comparant ces éléments avec la vue satellite ou <class=\"Inter24Bold_Orange\">Street View</class>, on peut confirmer une adresse précise. Cette comparaison visuelle permet de valider la position des bâtiments ou des routes pour transformer une simple photo en une preuve de localisation."
      let text = this.scene.add.rexTagText(160, 140, txt, configText).setOrigin(0).setWordWrapWidth(560);
      this.add(text);

      let Y = text.y + text.height + 48;
     
      // Ajout du bouton de fermeture
      let closeBtn = new ButtonRounded(this.scene, background.width/2 + bande.width/2, Y, {
         text: "Continuer",
         color: Colors.Elmt.Orange,
         textColor: Colors.Text.White,
         hoverColor: Colors.Elmt.Blue,
      })
      closeBtn.y += closeBtn.height/2;
      this.add(closeBtn);

      closeBtn.setClickFunction(() => {
         this.animOut(() => {
            this.scene.closeDebrief()
         })      
      })

      this.setSize(background.width, background.height);
   }

   animIn() {
      this.x = this.scene.width;

      this.soundManager.playOnce('PaperSlide4')
   
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width - this.width,
         duration: 500,
         ease: 'Cubic.easeInOut'
       });

   }

   animOut(endFunc) {
      this.soundManager.playOnce('PaperSlide4')
      this.scene.tweens.add({
         targets: this,
         x: this.scene.width,
         duration: 500,
         ease: 'Cubic.easeInOut',
         onComplete: () => {
            // Animation complete
            if(endFunc) endFunc();
         }
       });
   }
}